import clsx from "clsx";
import * as React from "react";
import sx from "./collapsible-area.module.css";

const CollapsibleArea: React.FC<
	React.PropsWithChildren<{ className?: string }>
> = ({ className, children }) => {
	const [open, setOpen] = React.useState(false);

	return (
		<>
			<div
				className={clsx(sx.collapsible, className, {
					[sx.open]: open,
				})}
			>
				{children}
			</div>
			{!open && (
				<div className="flex justify-center">
					<button
						className="flex flex-row flex-shrink-0 items-center pb-2 pt-3 px-4 text-black font-rigBold text-sm font-bold bg-primary uppercase"
						type="button"
						onClick={() => setOpen(true)}
					>
						Lees meer
					</button>
				</div>
			)}
		</>
	);
};

export default CollapsibleArea;
